<div class="spacer">
  <p-panel>
    <div class="grid">
      <div class="col-12">
        <p-header class="sub-section-header">Add Property</p-header>
      </div>
      <div class="col-12 md:col-6 lg:col-2">
        <div class="stacked-content">
          <span class="content-label">
            Domicile:
            <span class="required">*</span>
          </span>
          <input id="domicile" type="text" class="is-input" name="domicile" pInputText [(ngModel)]="domicile" />
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-3">
        <div class="stacked-content">
          <span class="content-label">
            Property Type:
            <span class="required">*</span>
          </span>
          <p-select class="is-dropdown" placeholder=" " [options]="propTypes" name="propType" [(ngModel)]="propType"
            [dropdownIcon]="'fa fa-chevron-down'">
          </p-select>
        </div>
      </div>      
      <div class="col-12 md:col-6 lg:col-3">
        <div class="stacked-content">
          <span class="content-label">
            Property Name:
            <span class="required">*</span>
          </span>
          <input id="propName" type="text" class="is-input" name="propName" pInputText [(ngModel)]="propName" />
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-2">
        <div class="stacked-content">
          <span class="content-label">
            Property Value:
            <span class="required">*</span>
          </span>
          <input id="propValue" type="text" class="is-input" name="propValue" pInputText [(ngModel)]="propValue" />
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-2">
        <div class="content-end">
          <button name="addProperty" pButton type="button" label="Add Property" (click)="addProperty()"
            class="button primary p-button-rounded">
          </button>
        </div>
      </div>
    </div>
    <div class="grid">
      <div class="col-12 md:col-6">
        <p-header class="sub-section-header">Export Properties</p-header>
      </div>
      <div class="col-12 md:col-6">
        <p-header class="sub-section-header">Import Properties</p-header>
      </div>
      <div class="col-12 md:col-6 lg:col-6" *ngIf='this.existingProperties?.length > 0'>
        <div class="content-start">
          <button name="Export Properties" pButton type="button" label="Export Properties" (click)="exportProperties()"
            class="button primary p-button-rounded"></button>
        </div>
      </div>
      <!-- <div class="col-12 md:col-6 lg:col-3">
        <div class="content-end">
          <input id="fileName" type="file" class="is-input" name="fileName" pInputText
            (change)="onFileChanged($event)" />
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-3">
        <div class="content-end">
          <button *ngIf="this.fileUploaded != undefined && this.fileUploaded != null && this.isValidFileName"
            name="Import Properties" pButton type="button" label="Import Properties" (click)="uploadProperties()"
            class="button primary p-button-rounded"></button>
        </div>
      </div> -->
      <!------------------------------------------------------------------------------------------------!!--->
      <div class="col-12 md:col-6 lg:col-3">
        <div class="content-end">
          <input id="fileName" type="file" class="is-input" name="fileName" pInputText  #fileInput
            (change)="onFileSelected($event)" />
        </div> 
      </div>
      <div class="col-12 md:col-6 lg:col-3">
        <div class="content-end">
          <button *ngIf="this.selectedFile != undefined && this.selectedFile != null && this.isValidFileName"
            name="Import Properties" pButton type="button" label="Import Properties" (click)="uploadFile()"
            class="button primary p-button-rounded"></button>
        </div>
      </div>
    </div>
    <div class="grid">
      <div class="col-12 md:col-6 lg:col-2"></div>
      <div class="col-12 md:col-6 lg:col-8">
        <div *ngFor="let msg of errMsgs">
          <p-message [severity]="msg.severity" [text]="msg.summary" [closable]="true"></p-message>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-2"></div>
    </div>
  </p-panel>
</div>

<div class="spacer" *ngIf='this.existingProperties?.length > 0'>
  <p-panel>
    <div class="grid">
      <p-header class="sub-section-header">Existing Properties</p-header>
      <div class="newtable">
      <p-table *ngIf="this.existingProperties?.length > 0" #alloProperty name="alloPropertiesTable"
        [value]="existingProperties" [columns]="alloPropCols" [scrollable]="true" [resizableColumns]="true"
        sortMode="multiple" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 20, 30, 40, 50]"
        class="data-table shrink-headers" scrollHeight="450px">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field">
              <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order">
              </p-sortIcon>
              {{ col.header }}
            </th>
          </tr>
          <tr class="column-filters">
            <th *ngFor="let col of columns" [ngSwitch]="col.field">
              <input *ngIf="col.field != Select" pInputText type="text"
                (input)="alloProperty.filter($event.target.value, col.field, 'contains')"
                (change)='filterCapture($event, alloProperty)'>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-alloProperty>
          <tr>
            <td>
              <p-checkbox #chkEnable name="alloPropRec" [value]="alloProperty" [(ngModel)]="alloSelectedProperty">
              </p-checkbox>
            </td>
            <td>{{ alloProperty.domicile }}</td>
            <td>
              <input size="8" type="text" pInputText [(ngModel)]="alloProperty.propType"
                [disabled]="!chkEnable.checked">
            </td>
            <td>
              <input size="8" type="text" pInputText [(ngModel)]="alloProperty.propName"
                [disabled]="!chkEnable.checked">
            </td>
            <td>
              <input size="8" type="text" pInputText [(ngModel)]="alloProperty.currentPropValue"
                [disabled]="!chkEnable.checked">
            </td>
            <td>{{ alloProperty.createdBy }}</td>
            <td>{{ formatDate(alloProperty.createdDate) }}</td>
            <td>{{ alloProperty.updatedBy }}</td>
            <td>{{ formatDate(alloProperty.updatedDate) }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>

      <div class="col-12 md:col-6 lg:col-12"></div>
      <div class="col-12 md:col-6 lg:col-6" *ngIf="this.alloSelectedProperty?.length > 0">
        <div class="content-start">
          <button name="Update Properties" pButton type="button" label="Update Selected" (click)="updateProperties()"
            class="button primary p-button-rounded"></button>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-6" *ngIf="this.alloSelectedProperty?.length > 0">
        <div class="content-end">
          <button name="Delete Properties" pButton type="button" label="Delete Selected" (click)="deleteProperties()"
            class="button primary p-button-rounded"></button>
        </div>
      </div>
    </div>
    <div class="grid">
      <div class="col-12 md:col-6 lg:col-2"></div>
      <div class="col-12 md:col-6 lg:col-8">
        <div *ngFor="let msg of tblErrMsgs">
          <p-message [severity]="msg.severity" [text]="msg.summary" [closable]="true"></p-message>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-2"></div>
    </div>
  </p-panel>
</div>